module.exports = __webpack_public_path__ + "static/media/icons_Bilan de Pubalgie.2e1a151a.svg";